import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import {
  ClearPsidsResponse,
  PSIDs,
} from '../../shared/interfaces/survey.interface';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { SharedDataService } from '../../shared/services/shared-data-service/shared-data-service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'ps-ui-clear-psid-modal',
  templateUrl: './clear-or-view-psid-modal.component.html',
  styleUrls: ['./clear-or-view-psid-modal.component.css'],
})
export class ClearOrViewPsidModalComponent implements OnInit, OnDestroy {
  public surveyId!: number;
  public isClearRequest: boolean = false;
  public psidsToDisplay: string = '';
  public psids!: Array<PSIDs>;
  constructor(
    private _modalRef: ModalRef<
      ClearOrViewPsidModalComponent,
      {
        surveyId: number;
        psids: Array<PSIDs>;
        isClearRequest: boolean;
      }
    >,
    @Inject(ModalData)
    private _modalData: {
      surveyId: number;
      psids: Array<PSIDs>;
      isClearRequest: boolean;
    },
    @Inject(DOCUMENT) private _document: Document,
    private _buyerApiService: BuyerApiService,
    private _toastr: ToasterService,
    private _sharedDataService: SharedDataService,
    private _renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.surveyId = this._modalData.surveyId;
    this.psids = this._modalData.psids;
    this.isClearRequest = this._modalData.isClearRequest;
    if (this.psids?.length) {
      this.psidsToDisplay = this.psids.map((item) => item.PSID).join(',');
    }
    this._renderer.addClass(this._document.body, 'modal-open');
  }

  clearUploadedPSIDs() {
    this._buyerApiService
      .clearUploadedPSIDs(this.surveyId)
      .subscribe((resp: ClearPsidsResponse) => {
        this._toastr.success('Sucess! PSIDs have been cleared');
        this._sharedDataService.setPsidModelClose(false);
        this._modalRef.close();
      });
  }

  close() {
    this._modalRef.close();
    this._sharedDataService.setPsidModelClose(true);
  }
  ngOnDestroy() {
    this._renderer.removeClass(this._document.body, 'modal-open');
  }
}
